import React from 'react';
import { useNavigate } from 'react-router-dom';
import { clearAuthState } from '../../utils/auth';
import './Unauthorized.css';

function Unauthorized() {
  const navigate = useNavigate();

  const handleGoToDashboard = () => {
    navigate('/dashboard');
  };

  const handleLogout = () => {
    clearAuthState();
    navigate('/');
  };

  return (
    <div className="unauthorized-container">
      <div className="unauthorized-content">
        <div className="unauthorized-icon">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="currentColor" strokeWidth="2"/>
            <path d="M4.93 4.93L19.07 19.07" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
          </svg>
        </div>
        <h1 className="unauthorized-code">403</h1>
        <h2 className="unauthorized-title">Access Denied</h2>
        <p className="unauthorized-message">
          You don't have permission to access this page. Please contact your administrator if you believe this is an error.
        </p>
        <div className="unauthorized-buttons">
          <button className="unauthorized-button primary" onClick={handleGoToDashboard}>
            Go to Dashboard
          </button>
          <button className="unauthorized-button secondary" onClick={handleLogout}>
            Logout
          </button>
        </div>
      </div>
    </div>
  );
}

export default Unauthorized;
